import { SettingsStorageBase, ISettings } from 'web-core-src';

export abstract class SettingsBase implements ISettings {
    public abstract init(): void;

    public abstract setDefaultValues(): void;
    public abstract translateDefaultValues(): void;

    public version: string;
    public settingsStorage: SettingsStorageBase;

    public createPreImportBackup(): void {
        this.settingsStorage.createPreImportBackup();
    }

    public setAppSettings(settingsJsonString: string): void {
        this.settingsStorage.setAppSettings(settingsJsonString);
    }

    public getAppSettings(): ISettings {
        return this.settingsStorage.getAppSettings();
    }

    public async loadSettingsFromStorage(): Promise<void> {
        return this.settingsStorage.loadSettingsFromStorage();
    }

    public updateSettingsInStorage(): void {
        this.settingsStorage.updateSettingsInStorage();
    }

    public getCurrentSettingsJSON(): string {
        return this.settingsStorage.getCurrentSettingsJSON();
    }
}
